import * as React from 'react'

import { Meta } from '~/components'
import { manufacturerProductQuery, vendorProductQuery } from '~/gql/queries'
import ProductScreen from '~/screens/product'
import { flags, httpStatusCodes } from '~/utils/constants'
import isBrowser from '~/utils/is-browser'

import ErrorPage from './_error'

interface ProductPageProps {
  productSlug: string
  ssrProduct: any
}

export default function ProductPage(props: ProductPageProps) {
  const { productSlug, ssrProduct } = props

  if (!productSlug) {
    return <ErrorPage statusCode={httpStatusCodes.NOT_FOUND} />
  }

  return (
    <>
      <Meta />
      <ProductScreen productSlug={productSlug} ssrProduct={ssrProduct} />
    </>
  )
}

ProductPage.getInitialProps = async (pageContext: PageContext<{ productSlug: string }>) => {
  const { query, vendor, hasFlag, apolloClient } = pageContext

  const { productSlug } = query

  const isMultiDistributorD2C = hasFlag(flags.MULTI_DISTRIBUTOR_D2C)

  if (isBrowser && !isMultiDistributorD2C) {
    return {
      productSlug,
    }
  }

  async function getVendorProduct() {
    const response = await apolloClient.query({
      query: vendorProductQuery,
      variables: {
        slug: productSlug,
      },
    })

    return response.data.vendor.product
  }

  async function getManufacturerProduct() {
    const response = await apolloClient.query({
      query: manufacturerProductQuery,
      variables: {
        slug: productSlug,
      },
    })

    return response.data.manufacturer.product
  }

  try {
    if (!isMultiDistributorD2C) {
      const ssrProduct = await getVendorProduct()

      return {
        productSlug,
        ssrProduct,
      }
    }

    let ssrProduct = await getManufacturerProduct()

    if (ssrProduct.vendor.id === vendor.id) {
      ssrProduct = await getVendorProduct()
    }

    return {
      productSlug,
      ssrProduct,
    }
  } catch (error) {
    console.error(error)

    if (pageContext.res) {
      // eslint-disable-next-line no-param-reassign
      pageContext.res.statusCode = httpStatusCodes.NOT_FOUND
    }
  }
}
